export const BITFINEX_CONNECT = 'BITFINEX_CONNECT';
export const BITFINEX_DISCONNECT = 'BITFINEX_DISCONNECT';
export const UPDATE_ORDER_BOOK = 'UPDATE_ORDER_BOOK';

export const BITFINEX_CONNECTED = 'BITFINEX_CONNECTED';
export const BITFINEX_DISCONNECTED = 'BITFINEX_DISCONNECTED';
export const CHANGE_PARAMETER = 'CHANGE_PARAMETER';
export const CHANGE_DISPLAY_PARAMETER = 'CHANGE_DISPLAY_PARAMETER';
